const PropTypes = require('prop-types');

module.exports = {
  postId: PropTypes.number.isRequired
};
